import React from 'react'

export default function CuisineStart({data, isCuisine = true, headingTag = "h1"}) {
  const HeadingTag = headingTag;

  return (
    <>
      <section className="cuisine-start-area">
        <div className="container">
          <div className="row justify-content-end">
            <div className="col-lg-9 col-md-10">
              <div className={`cuisine-start-box ${isCuisine ? "" : "spa-start-box"}`}>
                <div>
                  <img src={data?.topLeftImg} alt="cuisine" className="img-responsive wow animate__animated animate__fadeInRight" data-wow-delay="0.2s" data-wow-duration="1.3s" />
                  <img src={data?.topRightImg} alt="cuisine" className="img-responsive wow animate__animated animate__fadeInRight" data-wow-delay="0.3s" data-wow-duration="1.3s" />
                </div>
                <img src={data?.bottomImg} alt="cuisine" className="img-responsive"/>

                <HeadingTag className="heading">{data?.title}</HeadingTag>

                {data?.timing && <span>{data?.timing}</span>}
                <p dangerouslySetInnerHTML={{ __html: data?.desc }} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
